import type { ApplyLicenseResponse, LicenseStatus } from '@/types/license';
import { engineClient } from '@/services/engine/engine-client';
import { API_PREFIX, ENDPOINTS } from '@/services/engine/endpoints';

const ENDPOINT = `${API_PREFIX}${ENDPOINTS.license}`;

export class LicenseService {
    public static async getStatus(): Promise<LicenseStatus> {
        return await engineClient.get<LicenseStatus>(`${ENDPOINT}/status`);
    }

    public static async apply(
        document: unknown,
    ): Promise<ApplyLicenseResponse> {
        return await engineClient.post<ApplyLicenseResponse>(
            `${ENDPOINT}/apply`,
            {
                document,
            },
        );
    }
}
